import { useHmo } from '@hook'
import { yupResolver } from '@hookform/resolvers/yup'
import { HmoResAttributes } from '@type/hmo.type'
import { FormButton, FormInputField, Modal, SelectInputField } from '@ui'
import { getError, showToast } from '@util'
import { Box, Form } from 'grommet'
import { FormProvider, useForm } from 'react-hook-form'
import * as yup from 'yup'

type Props = {
  onClose: () => void
  id?: string
  defaultData?: HmoResAttributes
}

const hmoSchema = yup.object({
  address: yup.string().nullable(),
  name: yup.string().required('Name is required'),
  status: yup.string().nullable()
})

export const HmoStatusOptions = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' }
]

export const AddHmo = ({ onClose, defaultData, id }: Props) => {
  const methods = useForm({ resolver: yupResolver(hmoSchema), values: defaultData })
  const { createHmo, updateHmo } = useHmo()
  const { reset, formState, handleSubmit } = methods

  const onSubmit = async (data: any) => {
    const formVal = {
      data: {
        attributes: {
          ...data
        },
        type: 'hmo'
      }
    }
    try {
      id ? await updateHmo({ formVal, id: id || '' }) : await createHmo(formVal)
      showToast(`HMO ${id ? 'updated' : 'added'} successfully`)
      onClose()
      reset()
    } catch (error) {
      getError(error)
    }
  }

  return (
    <FormProvider {...methods}>
      <Modal
        onClose={() => {
          onClose()
          reset()
        }}
        title={id ? 'Edit Hmo' : 'Add Hmo'}
      >
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Box flex={false} gap={'20px'} overflow="auto" pad={{ horizontal: '32px', vertical: '16px' }}>
            <Box pad="0">
              <FormInputField label="Name" name="name" placeholder="" />
            </Box>
            <SelectInputField
              label="Status"
              labelKey={({ label }) => label}
              name="status"
              options={HmoStatusOptions}
              valueKey={{ key: 'value', reduce: true }}
            />
          </Box>
          <FormButton isLoading={formState.isSubmitting} onClose={onClose} submit="Save" />
        </Form>
      </Modal>
    </FormProvider>
  )
}
